module.exports = __webpack_public_path__ + "static/media/23.3ab59528.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/23.png
// module id = 983
// module chunks = 0